// Bankkártyák feature — query-kulcs gyár + a lista-szűrő típusa. A tényleges hívásokat a route/komponens a
// tipizált ts-rest kliensen (`api.paymentCards.*`) intézi; a kulcsok itt élnek (cache-egységesítés). A
// `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van (a billing-profiles feature-mintára).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit). A `sort` a
 *  rendezés-KULCS (holderName | bankName | last4 | expiryYear | clientName), az `order` az irány; a `q` a szabad-
 *  szöveg. A státusz-facet (érvényes/lejár/lejárt) TISZTÁN kliens-oldali — nem része a szerver-kulcsnak. */
export interface PaymentCardListFilters {
  q: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista/refs cache egységes címzése (invalidálás + a create-form ügyfél-választója). */
export const paymentCardKeys = {
  all: ['payment-cards'] as const,
  lists: () => ['payment-cards', 'list'] as const,
  list: (filters: PaymentCardListFilters) => ['payment-cards', 'list', filters] as const,
  /** A create-form ügyfél-választójának refs-adata (foundation clients). */
  clientRefs: () => ['payment-cards', 'client-refs'] as const,
};
